import { INTEGRATION_REQUESTS_PATH, INTEGRATION_REQUESTS_TITLE } from '../config';
import { commercePageBreadcrumbs } from '../../../config';
import { useNavigate } from 'react-router-dom';
import { useMemo } from 'react';

const useIntegrationRequestBreadcrumbs = () => {
  const navigate = useNavigate();

  return useMemo(
    () => [
      ...commercePageBreadcrumbs(navigate),
      {
        label: INTEGRATION_REQUESTS_TITLE,
        onClick: () => navigate(INTEGRATION_REQUESTS_PATH),
      },
    ],
    [navigate]
  );
};

export default useIntegrationRequestBreadcrumbs;
